import { computed, ref, Ref, watch } from 'vue'
import { useStore } from 'vuex'
import { clearToast, showToastLoading } from '@/utils/tools'
/* 
  处理短信验证信息
*/
export interface useSmsVerifyOptionType<T> {
  timeTotal?: number
  api: (params: T) => Promise<void>
}
export function useSmsVerify<T>(option: useSmsVerifyOptionType<T>): {
  timeValue: Ref<number>
  sending: Ref<boolean>
  sendSmsMessage: (params: T) => Promise<void>
  resendHandle: () => void
  hasSended: Ref<boolean>
  beforeSendSmsCodeHandle: () => void
} {
  const vueStore = useStore()
  const timeValue: Ref<number> = ref(0)
  const sending: Ref<boolean> = ref(false)
  const hasSended: Ref<boolean> = ref(false)
  const timeTotal = option?.timeTotal || 60
  let timeId = 0
  let waitUserInfo = false
  const requestingUserInfo = computed(() => {
    return vueStore.state.requestingUserInfo
  })
  watch(requestingUserInfo, () => {
    if (!requestingUserInfo.value) {
      if (waitUserInfo) {
        clearToast()
      }
    }
  })
  async function beforeSendSmsCodeHandle() {
    if (requestingUserInfo.value) {
      // 表示正在请求手机号中
      showToastLoading({ message: '获取手机号...' })
      waitUserInfo = true
      return Promise.reject()
    }
  }
  function initTimeCount() {
    // 倒计时
    clearTimeout(timeId)
    timeValue.value = timeTotal
    timeChangeHandle()
  }
  function timeChangeHandle() {
    if (timeValue.value === 0) {
      return
    }
    timeId = setTimeout(() => {
      timeValue.value = timeValue.value - 1
      timeChangeHandle()
    }, 1000)
  }
  async function sendSmsMessage(params: T) {
    // 发送短信
    if (sending.value || timeValue.value > 0) {
      return
    }
    sending.value = true
    hasSended.value = true
    try {
      initTimeCount()
      await option.api(params)
      sending.value = false
    } catch (e) {
      sending.value = false
      timeValue.value = 0
      clearTimeout(timeId)
      return Promise.reject(e)
    }
  }
  function resendHandle() {
    if (sending.value) {
      return
    }
    // sendSmsMessage()
  }
  return {
    timeValue,
    sendSmsMessage,
    sending,
    hasSended,
    resendHandle,
    beforeSendSmsCodeHandle,
  }
}
